import { FC } from 'react';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import auctionCampaignBiddingStrategyDetailsButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/auction_campaign_bidding_strategy_details_button_click';
import auctionCampaignBiddingStrategyTooltipElementShown from '@hh.ru/analytics-js-events/build/clickme/employer/auction/auction_campaign_bidding_strategy_tooltip_element_shown';
import { Button, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BiddingStrategy } from 'store/models/auctionData';

const TrlKeys = {
    labelTooltipContent: 'AuctionBuilder.BiddingStrategySelect.BiddingStrategyCard.auto.labelTooltipContent',
    labelTooltipButton: 'AuctionBuilder.BiddingStrategySelect.BiddingStrategyCard.auto.labelTooltipButton',
};

interface AutoStrategyLabelTooltipContentProps {
    vacancyId?: number;
    onDetailsButtonClick: () => void;
}

export const AutoStrategyLabelTooltipContent: FC<AutoStrategyLabelTooltipContentProps> = ({
    vacancyId,
    onDetailsButtonClick,
}) => {
    const trls = useTrls();
    const { isMobile } = useBreakpoint();

    const onShowDetails = () => {
        auctionCampaignBiddingStrategyDetailsButtonClick({
            biddingStrategy: BiddingStrategy.Auto,
            vacancyId: vacancyId ? String(vacancyId) : null,
        });
        onDetailsButtonClick();
    };

    return (
        <ElementShownAnchor
            fn={auctionCampaignBiddingStrategyTooltipElementShown}
            biddingStrategy={BiddingStrategy.Auto}
            vacancyId={vacancyId ? String(vacancyId) : null}
        >
            <Text typography={isMobile ? 'label-1-regular' : 'paragraph-2-regular'}>
                {trls(TrlKeys.labelTooltipContent)}
            </Text>
            <VSpacing default={isMobile ? 36 : 24} />
            <Button
                size={isMobile ? 'medium' : 'small'}
                mode="primary"
                style={isMobile ? 'accent' : 'constant'}
                onClick={onShowDetails}
                stretched
            >
                {trls(TrlKeys.labelTooltipButton)}
            </Button>
            {isMobile && <VSpacing default={36} />}
        </ElementShownAnchor>
    );
};
